module.exports = __webpack_public_path__ + "static/media/image.b62c7c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/image.png
// module id = 1325
// module chunks = 0